export const DEFAULT_MAXNUMBEROFATTACHMENTS: number = 3;
export const DEFAULT_MAXNUMBEROFATTACHMENTS_EXPERIMENT: number = 5;
